document.addEventListener('DOMContentLoaded', () => {
  const mainForm = document.querySelector('.provider-filters__form:not(.provider-filters__form--modal)');
  const modalForm = document.querySelector('.provider-filters__form--modal');
  const stickyBtn = document.querySelector('.provider-filters__button');
  const filtersSection = document.querySelector('.team-cards__filters');

  if (!mainForm || !modalForm) return;

  // ---------------------------------------------------------------------------
  // Mobile location UI
  // ---------------------------------------------------------------------------

  const root = mainForm;

  const elements = {
    locationField: root.querySelector('.provider-filters__field--location'),
    locationFieldGroup: root.querySelector('.provider-filters__field-group'),
    locationFieldGroupLocation: root.querySelector('.provider-filters__field-group-location'),
    locationInput: root.querySelector('#location-input'),
    locationLabel: root.querySelector('.provider-filters__field--location .provider-filters__label'),
    closeButton: root.querySelector('.provider-filters__location-close'),
  };

  if (
    elements.locationField &&
    elements.locationFieldGroup &&
    elements.locationFieldGroupLocation &&
    elements.locationInput &&
    elements.locationLabel
  ) {
    const MOBILE_BREAKPOINT = 600; // Should match $bp2 in SCSS

    let isMobileOpen = false;
    let dataSpan = null;
    let mobileButton = null;

    const updateLocationData = () => {
      if (dataSpan && elements.locationInput) {
        const currentValue = elements.locationInput.value ||
          elements.locationInput.getAttribute('placeholder') ||
          '';
        dataSpan.textContent = currentValue;
      }
    };

    const toggleFieldGroupVisibility = () => {
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        updateLocationData();
        if (!isMobileOpen) {
          elements.locationFieldGroupLocation.setAttribute('hidden', '');
        }
      } else {
        elements.locationFieldGroupLocation.removeAttribute('hidden');
        // Restore the mobile button too — it's hidden while the fields are open,
        // and leaving it hidden makes the fields unreachable back under the
        // breakpoint (group re-hidden, no button left to reopen it).
        if (mobileButton) mobileButton.removeAttribute('hidden');
        isMobileOpen = false;
      }
    };

    const createMobileButton = () => {
      const labelText = elements.locationLabel.textContent.trim();
      const locationData = elements.locationInput.value ||
        elements.locationInput.getAttribute('placeholder') ||
        '';

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button--outline-alt provider-filters__location-button';

      const labelSpan = document.createElement('span');
      labelSpan.textContent = labelText;
      labelSpan.className = 'provider-filters__location-label';
      button.appendChild(labelSpan);

      dataSpan = document.createElement('span');
      dataSpan.textContent = locationData;
      dataSpan.className = 'provider-filters__location-data';
      button.appendChild(dataSpan);

      button.addEventListener('click', () => {
        elements.locationFieldGroupLocation.removeAttribute('hidden');
        button.setAttribute('hidden', '');
        isMobileOpen = true;
      });

      elements.locationFieldGroup.insertBefore(button, elements.locationFieldGroup.firstChild);

      return button;
    };

    const setupCloseButton = (button) => {
      if (elements.closeButton) {
        elements.closeButton.addEventListener('click', (event) => {
          event.preventDefault();
          updateLocationData();
          button.removeAttribute('hidden');
          elements.locationFieldGroupLocation.setAttribute('hidden', '');
          isMobileOpen = false;
        });
      }
    };

    mobileButton = createMobileButton();
    setupCloseButton(mobileButton);
    toggleFieldGroupVisibility();

    new ResizeObserver(() => {
      toggleFieldGroupVisibility();
    }).observe(root);
  }

  // ---------------------------------------------------------------------------
  // Clone filter fields into modal
  // ---------------------------------------------------------------------------

  function initProviderFilterModal() {
    const sourceFields = mainForm.querySelector('.provider-filters__fields');
    if (!sourceFields) return;

    const clone = sourceFields.cloneNode(true);

    // Rewrite IDs to prevent duplicates; store originals as data-sync-id for sync lookup
    clone.querySelectorAll('[id]').forEach((el) => {
      el.dataset.syncId = el.id;
      el.id = `${el.id}-modal`;
    });

    // Update label for= attributes to match rewritten IDs
    clone.querySelectorAll('[for]').forEach((el) => {
      el.setAttribute('for', `${el.getAttribute('for')}-modal`);
    });

    // Remove mobile-only controls — the modal always shows all fields
    const mobileBtn = clone.querySelector('.provider-filters__location-button');
    if (mobileBtn) mobileBtn.remove();
    const closeBtn = clone.querySelector('.provider-filters__location-close');
    if (closeBtn) closeBtn.remove();

    // Ensure the location field group isn't hidden (mobile JS may have hidden it)
    const locationGroup = clone.querySelector('.provider-filters__field-group-location');
    if (locationGroup) locationGroup.removeAttribute('hidden');

    modalForm.appendChild(clone);
  }

  // ---------------------------------------------------------------------------
  // Move focus into the modal when it opens
  // ---------------------------------------------------------------------------

  function initModalFocus() {
    const modal = modalForm.closest('.modal');
    if (!modal) return;

    new MutationObserver(() => {
      if (modal.getAttribute('aria-hidden') === 'false' && !modal.contains(document.activeElement)) {
        const modalClose = modal.querySelector('.modal__close');
        if (modalClose) modalClose.focus();
      }
    }).observe(modal, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  // ---------------------------------------------------------------------------
  // Two-way field sync between main form and modal form
  // ---------------------------------------------------------------------------

  let syncing = false;

  function syncField(sourceEl, targetForm) {
    if (syncing) return;
    const syncId = sourceEl.dataset.syncId || sourceEl.id;
    if (!syncId) return;
    const escaped = CSS.escape(syncId);
    const target =
      targetForm.querySelector(`[data-sync-id="${escaped}"]`) ||
      targetForm.querySelector(`#${escaped}`);
    if (!target) return;

    syncing = true;
    try {
      if (sourceEl.type === 'checkbox' || sourceEl.type === 'radio') {
        target.checked = sourceEl.checked;
      } else {
        target.value = sourceEl.value;
      }
    } finally {
      syncing = false;
    }
  }

  function syncAllFields(sourceForm, targetForm) {
    syncing = true;
    try {
      sourceForm.querySelectorAll('input, select, textarea').forEach((el) => {
        const syncId = el.dataset.syncId || el.id;
        if (!syncId) return;
        const escaped = CSS.escape(syncId);
        const target =
          targetForm.querySelector(`[data-sync-id="${escaped}"]`) ||
          targetForm.querySelector(`#${escaped}`);
        if (!target) return;
        if (el.type === 'checkbox' || el.type === 'radio') {
          target.checked = el.checked;
        } else {
          target.value = el.value;
        }
      });
    } finally {
      syncing = false;
    }
  }

  function initFilterSync() {
    const onFieldEvent = (targetForm) => (e) => {
      if (!e.target.matches('input, select, textarea')) return;
      syncField(e.target, targetForm);
    };

    mainForm.addEventListener('input', onFieldEvent(modalForm));
    mainForm.addEventListener('change', onFieldEvent(modalForm));
    modalForm.addEventListener('input', onFieldEvent(mainForm));
    modalForm.addEventListener('change', onFieldEvent(mainForm));

    // Reset: after native reset completes, mirror state to the other form
    mainForm.addEventListener('reset', () => setTimeout(() => syncAllFields(mainForm, modalForm), 0));
    modalForm.addEventListener('reset', () => setTimeout(() => syncAllFields(modalForm, mainForm), 0));

    // Apply from modal: sync fields, close modal, then submit the main form
    modalForm.addEventListener('submit', (e) => {
      e.preventDefault();
      syncAllFields(modalForm, mainForm);
      /* global MicroModal */
      if (typeof MicroModal !== 'undefined') {
        MicroModal.close('provider-filters-modal');
      }
      if (mainForm.requestSubmit) {
        mainForm.requestSubmit();
      } else {
        mainForm.submit();
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Sticky button: show after filters scroll out of view, hide after cards do
  // ---------------------------------------------------------------------------

  function initStickyButton() {
    if (!stickyBtn || !filtersSection) return;

    const cardsRow = document.querySelector('.team-cards__row');

    if (!cardsRow) return;

    function updateVisibility() {
      const filtersPassed = filtersSection.getBoundingClientRect().bottom < 0;
      const cardsPassed = cardsRow.getBoundingClientRect().bottom < 0;

      if (filtersPassed && !cardsPassed) {
        stickyBtn.removeAttribute('hidden');
      } else {
        stickyBtn.setAttribute('hidden', '');
      }
    }

    const observer = new IntersectionObserver(updateVisibility, { threshold: 0 });
    observer.observe(filtersSection);
    observer.observe(cardsRow);
    window.addEventListener('scroll', updateVisibility, { passive: true });
  }

  initProviderFilterModal();
  initModalFocus();
  initFilterSync();
  initStickyButton();
});
